var map = {
	"./tyre-default.png": 141,
	"./tyre-green-1.png": 157,
	"./tyre-green-2.png": 275,
	"./tyre-green-3.png": 276,
	"./tyre-green.png": 103,
	"./tyre-high.png": 124,
	"./tyre-low.png": 155,
	"./tyre-middle.png": 140,
	"./tyre-red-1.png": 277,
	"./tyre-red-2.png": 278,
	"./tyre-red-3.png": 279,
	"./tyre-red.png": 126,
	"./tyre-yellow-1.png": 280,
	"./tyre-yellow-2.png": 281,
	"./tyre-yellow-3.png": 282,
	"./tyre-yellow.png": 156
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 360;